import { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { Star } from "lucide-react";
import { bookOnVrbo } from "@/lib/booking";
import { PROPERTY } from "@/data/property";

export function StickyBookBar() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      const past = window.scrollY > window.innerHeight * 0.9;
      const nearBottom = window.innerHeight + window.scrollY > document.body.scrollHeight - 320;
      setShow(past && !nearBottom);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <AnimatePresence>
      {show && (
        <motion.div
          initial={{ y: 80, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 80, opacity: 0 }}
          transition={{ duration: 0.4, ease: [0.22, 1, 0.36, 1] }}
          data-testid="sticky-book-bar"
          className="fixed bottom-4 left-1/2 z-50 -translate-x-1/2 w-[calc(100%-2rem)] max-w-2xl"
        >
          <div className="flex items-center justify-between gap-4 rounded-full border border-black/5 bg-background/85 backdrop-blur-xl px-4 py-3 shadow-2xl md:px-6">
            <div className="min-w-0">
              <p className="font-display text-lg md:text-xl leading-none text-foreground truncate">{PROPERTY.name}</p>
              <p className="mt-1 flex items-center gap-1.5 text-xs text-muted-foreground">
                <Star className="h-3 w-3 fill-accent text-accent" strokeWidth={1} />
                {PROPERTY.rating}/10 · Sleeps {PROPERTY.sleeps}
              </p>
            </div>
            <button
              onClick={() => bookOnVrbo("sticky")}
              data-testid="sticky-book-button"
              className="shrink-0 inline-flex items-center gap-2 rounded-full bg-primary px-6 py-3 text-sm font-medium tracking-wide text-primary-foreground transition-all duration-300 hover:gap-3 hover:bg-primary/90"
            >
              Book on VRBO
              <span aria-hidden>&rarr;</span>
            </button>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
